<div class="auth-bg">
    <div class="authentication-box">
      <div class="text-center"><img class="imglogo" src="assets/images/netsolin-logo.jpeg" alt=""></div>
      <div class="card mt-4 p-4">
        <h4 class="text-center">Registro nuevo Usuario</h4>
        <h6 class="text-center">Ingrese sus datos para registrarse</h6>
        <form class="theme-form" [formGroup]="usuarForm">
          <div class="form-row">
            <div class="col-md-6">
                <div class="form-group">
                    <label class="col-form-label pt-0">Empresa</label>
                    <input class="form-control" formControlName="empresa" type="text" required="" (blur)="blurEmpresa()">
                    <div *ngIf="usuarForm.controls.empresa.touched && usuarForm.controls.empresa.errors?.required"
                        class="text text-danger mt-1">
                        Nit empresa es requerido
                    </div>
                    <div *ngIf="usuarForm.controls.empresa.touched && usuarForm.controls.empresa.errors?.name"
                        class="text text-danger mt-1">
                        Empresa invalida
                    </div>
                </div>
                <div *ngIf="usuarForm.controls.empresa.invalid && usuarForm.controls.empresa.dirty" class="text text-danger mt-1">
                    La empresa {{ usuarForm.controls.empresa.value }} No se encontro, Contactenos.
                  </div>

                  <div *ngIf="usuarForm.controls.empresa.valid" class="text text-success mt-1">
                    {{ usuarForm.controls.empresa.value }} - {{ oapp.datosEmpre.nombre}}
                  </div>

                  <div *ngIf="usuarForm.controls.empresa.pending" class="text text-info mt-1 ">
                    Mantenga presionado ... Comprobando existencia de {{ usuarForm.controls.empresa.value }}
                  </div>
              </div>
              <div class="col-md-6 form-group">
                <label class="col-form-label pt-0">Identificacion</label>
                    <input class="form-control" formControlName="id" type="text" required="" (blur)="blurId()">
                    <div *ngIf="usuarForm.controls.id.touched && usuarForm.controls.id.errors?.required"
                        class="text text-danger mt-1">
                       Identificación es requerido
                    </div>
                    <div *ngIf="usuarForm.controls.id.touched && usuarForm.controls.id.errors?.name"
                      class="text text-danger mt-1">
                      Id invalido
                    </div>
                    <div *ngIf="usuarForm.controls.id.touched && usuarForm.controls.id.errors?.name"
                        class="text text-danger mt-1">
                        Identificacion invalida
                    </div>
                    <div *ngIf="usuarForm.controls.id.invalid && usuarForm.controls.id.dirty" class="text text-danger mt-1">
                      El usuario {{ usuarForm.controls.id.value }} Ya se encontro creado, Contactenos.
                    </div>
                    <div *ngIf="usuarForm.controls.id.valid" class="text text-success mt-1">
                      {{ usuarForm.controls.id.value }}
                    </div>
                    <div *ngIf="usuarForm.controls.id.pending" class="text text-info mt-1 ">
                      Mantenga presionado ... Comprobando existencia de id {{ usuarForm.controls.id.value }}
                    </div>
              </div>
          </div>
          <div class="form-row">
            <div class="col-md-6">
                <div class="form-group">
                    <label class="col-form-label pt-0">Nombre</label>
                    <input class="form-control" formControlName="name" type="text" required="">
                    <div *ngIf="usuarForm.controls.name.touched && usuarForm.controls.name.errors?.required"
                        class="text text-danger mt-1">
                        Nombre es requerido
                    </div>
                    <div *ngIf="usuarForm.controls.name.touched && usuarForm.controls.name.errors?.name"
                        class="text text-danger mt-1">
                        Nombre invalida
                    </div>
                </div>
              </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label class="col-form-label pt-0">Apellido</label>
                    <input class="form-control" formControlName="surname" type="text" required="">
                    <div *ngIf="usuarForm.controls.surname.touched && usuarForm.controls.surname.errors?.required"
                        class="text text-danger mt-1">
                        Apellido es requerido
                    </div>
                    <div *ngIf="usuarForm.controls.surname.touched && usuarForm.controls.surname.errors?.name"
                        class="text text-danger mt-1">
                        Apellido invalida
                    </div>
                </div>
            </div>
          </div>
          <div class="form-group">
              <label class="col-form-label pt-0">Email</label>
              <input class="form-control" formControlName="email" type="text" required="">
              <div *ngIf="usuarForm.controls.email.touched && usuarForm.controls.email.errors?.required"
                  class="text text-danger mt-1">
                  Email es requerido
              </div>
              <div *ngIf="usuarForm.controls.email.touched && usuarForm.controls.email.errors?.name"
                  class="text text-danger mt-1">
                  Email invalida
              </div>
              <div *ngIf="usuarForm.controls.email.invalid && usuarForm.controls.email.dirty" class="text text-danger mt-1">
                  El email {{ usuarForm.controls.email.value }} ya se encuentra registrado.
                </div>

                <div *ngIf="usuarForm.controls.email.valid" class="text text-success mt-1">
                  {{ usuarForm.controls.email.value }} se encuentra disponible
                </div>

                <div *ngIf="usuarForm.controls.email.pending" class="text text-info mt-1 ">
                  Mantenga presionado ... Comprobando existencia de {{ usuarForm.controls.email.value }}
                </div>

            </div>
          <div class="form-group">
              <label class="col-form-label pt-0">Contraseña</label>
              <input class="form-control" formControlName="psw" type="password" required="" placeholder="**********">
              <div *ngIf="usuarForm.controls.psw.touched && usuarForm.controls.psw.errors?.required"
                  class="text text-danger mt-1">
                  La contraseña es requerida
              </div>
              <div *ngIf="usuarForm.controls.psw.touched && usuarForm.controls.psw.errors?.name"
                  class="text text-danger mt-1">
                  Contraseña invalida
              </div>
          </div>

          <div class="form-group">
            <label class="col-form-label">Contraseña</label>
            <input class="form-control" formControlName="psw1" type="password" required="" placeholder="**********">
            <div *ngIf="usuarForm.controls.psw1.touched && !coincidenpsw"
            class="text text-danger mt-1">
            Las contraseñas no coinciden
        </div>
          </div>
          <div class="form-group form-row mt-3 mb-0">
              <!-- <div class="form-row"> -->
            <!-- <div class="col-sm-12"> -->
              <button class="btn btn-primary" [disabled]="!usuarForm.valid || !coincidenpsw"
                 (click)="submit(usuarForm.value)" type="submit">Registrarse</button>
              <button class="btn btn-primary" type="button" data-original-title="btn btn-info-gradien"
                                (click)="cancel()" title="">
                                Cancelar</button>
            <!-- </div> -->
          </div>
          <div class="form-row">
              <div class="col-sm-12">
                <div class="text-left mt-2 m-l-20"> ¿Ya es usuario?  <a class="btn-link text-capitalize" href="#/auth/login">Ingresar</a></div>
              </div>
            </div>
          </form>
      </div>
    </div>
  </div>
